import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import Button from '@prisjakt/ui-button';
import { Link } from 'react-router-dom';
import alertUnsubscribeMutation from './mutation.graphql';

import { PageHeader } from 'src/components/page';
import * as S from './styles';

class AlertUnsubscribePage extends React.PureComponent {
  renderBreadCrumb() {
    const path = [
      {
        id: '0',
        name: this.context.t('alerts', 'alerts.title'),
        pathName: '/alerts',
      },
    ];
    return (
      <Breadcrumb
        homeText={this.context.t('common', 'breadcrumb.home')}
        path={path}
      />
    );
  }

  render() {
    const { t } = this.context;
    const { product } = this.props.data.alertUnsubscribe;
    return (
      <S.Container>
        {this.renderBreadCrumb()}
        <S.Header>
          <PageHeader title={t('alerts', 'unsubscribe.removed')}>
            <S.Body>
              <div>
                <span>{t('alerts', 'unsubscribe.no-more-notifications')}</span>
                <S.ProductLink to={product.pathName}>
                  {product.name}
                </S.ProductLink>
              </div>
            </S.Body>
          </PageHeader>
        </S.Header>
        <S.Footer>
          <Button color="primary" component={<Link to="/" />}>
            {t('common', 'button.go-home')}
          </Button>
        </S.Footer>
      </S.Container>
    );
  }
}

AlertUnsubscribePage.contextType = AppContext;

AlertUnsubscribePage.propTypes = {
  data: PropTypes.shape({
    alertUnsubscribe: PropTypes.shape({
      product: PropTypes.shape({
        pathName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
};

AlertUnsubscribePage.defaultProps = {};

AlertUnsubscribePage.graphQL = alertUnsubscribeMutation;

AlertUnsubscribePage.variables = ({ key }) => ({
  token: key || '',
});

export default AlertUnsubscribePage;
